export default {
  'app.title': 'Hadiye Kılıç Butik',
  'app.subtitle': 'Yönetim Paneli',
  'nav.dashboard': 'Özet',
  'nav.sales': 'Satışlar',
  'nav.credit': 'Veresiye Takibi',
  'nav.suppliers': 'Tedarikçiler',
  'nav.expenses': 'Giderler',
  'nav.incomes': 'Gelirler',
  'nav.cash': 'Kasa / Cari',
  'nav.reports': 'Raporlar',
  'nav.settings': 'Ayarlar',
  'nav.logout': 'Çıkış Yap',
  'auth.login': 'Giriş Yap',
  'auth.register': 'Kayıt Ol',
  'auth.email': 'E-posta',
  'auth.password': 'Şifre',
  'auth.fullName': 'Ad Soyad',
  'auth.phone': 'Telefon',
  'auth.noAccount': 'Hesabınız yok mu?',
  'auth.hasAccount': 'Zaten hesabınız var mı?',
  'auth.loginError': 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.',
  'auth.registerError': 'Kayıt başarısız. Lütfen tekrar deneyin.',
  'common.add': 'Ekle',
  'common.edit': 'Düzenle',
  'common.delete': 'Sil',
  'common.save': 'Kaydet',
  'common.cancel': 'İptal',
  'common.close': 'Kapat',
  'common.search': 'Ara',
  'common.filter': 'Filtrele',
  'common.status': 'Durum',
  'common.date': 'Tarih',
  'common.amount': 'Tutar',
  'common.total': 'Toplam',
  'common.paid': 'Ödenen',
  'common.remaining': 'Kalan',
  'common.customer': 'Müşteri',
  'common.supplier': 'Tedarikçi',
  'common.phone': 'Telefon',
  'common.description': 'Açıklama',
  'common.notes': 'Notlar',
  'common.paymentType': 'Ödeme Tipi',
  'common.cash': 'Nakit',
  'common.card': 'Kart',
  'common.transfer': 'Havale',
  'common.installment': 'Parçalı',
  'common.credit': 'Veresiye',
  'common.completed': 'Tamamlandı',
  'common.pending': 'Bekliyor',
  'common.partial': 'Kısmi Ödendi',
  'common.overdue': 'Gecikti',
  'common.closed': 'Kapandı',
  'common.paidStatus': 'Ödendi',
  'common.unpaid': 'Ödenecek',
  'common.today': 'Bugün',
  'common.thisWeek': 'Bu Hafta',
  'common.thisMonth': 'Bu Ay',
  'common.custom': 'Özel Aralık',
  'common.all': 'Tümü',
  'common.actions': 'İşlemler',
  'common.detail': 'Detay',
  'common.payment': 'Ödeme',
  'common.whatsapp': 'WhatsApp',
  'common.closeDebt': 'Borcu Kapat',
  'common.loading': 'Yükleniyor...',
  'common.noData': 'Veri bulunamadı',
  'dashboard.todaySales': 'Bugünkü Satış',
  'dashboard.todayCollection': 'Bugünkü Tahsilat',
  'dashboard.todayExpense': 'Bugünkü Gider',
  'dashboard.cashStatus': 'Kasa Durumu',
  'dashboard.totalCredit': 'Toplam Veresiye Alacağı',
  'dashboard.totalSupplierDebt': 'Toplam Tedarikçi Borcu',
  'dashboard.monthlyIncome': 'Bu Ay Gelir',
  'dashboard.monthlyExpense': 'Bu Ay Gider',
  'dashboard.monthlyProfit': 'Bu Ay Net Kâr/Zarar',
  'dashboard.upcomingCollections': 'Yaklaşan Tahsilatlar',
  'dashboard.upcomingPayments': 'Yaklaşan Ödemeler',
  'dashboard.topDebtors': 'En Borçlu Müşteriler',
  'dashboard.upcomingSupplier': 'Yaklaşan Tedarikçi Ödemeleri',
  'sales.title': 'Satışlar',
  'sales.newSale': 'Yeni Satış Ekle',
  'sales.saleDate': 'Satış Tarihi',
  'sales.product': 'Ürün Açıklaması',
  'sales.payment': 'Ödeme Ekle',
  'sales.viewDetail': 'Detay Gör',
  'sales.edit': 'Satış Düzenle',
  'sales.delete': 'Satış Sil',
  'credit.title': 'Veresiye Takibi',
  'credit.totalCredit': 'Toplam Veresiye Alacağı',
  'credit.overdue': 'Geciken Borçlar',
  'credit.thisWeek': 'Bu Hafta Tahsil Edilecekler',
  'credit.closed': 'Borcu Kapanan Müşteriler',
  'credit.totalPurchases': 'Toplam Alışveriş',
  'credit.lastPayment': 'Son Ödeme Tarihi',
  'credit.customerDetail': 'Müşteri Detayı',
  'credit.paymentHistory': 'Ödeme Geçmişi',
  'credit.saleHistory': 'Satış Geçmişi',
  'suppliers.title': 'Tedarikçiler',
  'suppliers.newPurchase': 'Yeni Mal Alımı',
  'suppliers.purchaseDate': 'Alım Tarihi',
  'suppliers.dueDate': 'Vade Tarihi',
  'suppliers.totalCost': 'Toplam Mal Bedeli',
  'expenses.title': 'Giderler',
  'expenses.newExpense': 'Yeni Gider Ekle',
  'expenses.titleField': 'Gider Başlığı',
  'expenses.category': 'Kategori',
  'expenses.rent': 'Kira',
  'expenses.gas': 'Doğalgaz',
  'expenses.electric': 'Elektrik',
  'expenses.water': 'Su',
  'expenses.dues': 'Aidat',
  'expenses.staff': 'Personel',
  'expenses.shipping': 'Kargo',
  'expenses.advertising': 'Reklam',
  'expenses.accounting': 'Muhasebe',
  'expenses.tax': 'Vergi',
  'expenses.other': 'Diğer',
  'expenses.paymentStatus': 'Ödeme Durumu',
  'expenses.dueDate': 'Vade Tarihi',
  'incomes.title': 'Gelirler',
  'incomes.newIncome': 'Yeni Gelir Ekle',
  'incomes.titleField': 'Gelir Başlığı',
  'cash.title': 'Kasa / Cari Durum',
  'cash.totalSales': 'Toplam Satış',
  'cash.totalCollection': 'Toplam Tahsilat',
  'cash.totalExpenses': 'Toplam Gider',
  'cash.customerReceivable': 'Müşterilerden Alınacak',
  'cash.supplierPayable': 'Tedarikçilere Ödenecek',
  'cash.pendingExpenses': 'Bekleyen Giderler',
  'cash.netStatus': 'Net Kasa Durumu',
  'reports.title': 'Raporlar',
  'reports.dailySales': 'Günlük Satış Raporu',
  'reports.monthlyIncomeExpense': 'Aylık Gelir-Gider Raporu',
  'reports.creditReport': 'Müşteri Veresiye Raporu',
  'reports.supplierReport': 'Tedarikçi Borç Raporu',
  'reports.expenseCategory': 'Gider Kategorisi Raporu',
  'reports.profitLoss': 'Kâr-Zarar Raporu',
  'reports.overdueCollections': 'Geciken Tahsilatlar',
  'reports.upcomingPayments': 'Yaklaşan Ödemeler',
  'settings.title': 'Ayarlar',
  'settings.companyName': 'Firma Adı',
  'settings.address': 'Adres',
  'settings.logo': 'Logo',
  'settings.currency': 'Para Birimi',
  'settings.notifications': 'Bildirim Tercihleri',
  'settings.uploadLogo': 'Logo Yükle',
};